// removed by extract-text-webpack-plugin
module.exports = {"root":"_2L1klmBkdCZfmG5JgcUtDi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/pagination.scss
// module id = 1308
// module chunks = 0